function Error() {
	return (
		<div className=" text-3xl text-blue-600 px-4 text-center py-20">
			THIS LINK SEEM TO BE BROKEN NAVIGATE TO THE RIGHT LINK
		</div>
	);
}
export default Error;
